export const EstadosFacturaLiquidaciones = {
    PENDIENTE: 1,
    APROBADA: 2,
    RECHAZADA: 3,
    PENDIENTETL: 4,
    RECHAZADAAMODIFICAR: 5
  };
  
